import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { VideoEmbedBlock } from '@app/infrastructure/models/video-embed-block';
import { VideoEmbedUtils } from '@app/infrastructure/utils/video-embed.utils';

@Component({
  selector: 'app-video-embed-viewer',
  templateUrl: './video-embed-viewer.component.html',
  styleUrls: ['./video-embed-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoEmbedViewerComponent implements OnInit {
  @Input() videoEmbed: VideoEmbedBlock = new VideoEmbedBlock();

  html: SafeHtml;

  constructor(private videoEmbedUtils: VideoEmbedUtils) {}

  ngOnInit(): void {
    this.html = this.videoEmbedUtils.getVideoEmbedFromUrl(this.videoEmbed.url);
  }
}
